import React from "react";
import { Backdrop } from "@mui/material";
import logo from "src/assets/logo/logo-default.png";
import { useTranslation } from "react-i18next";

export default function ModalLoadingClock({ isOpen, imglogo }) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isOpen || false}
    >
      <div className="container_loader">
        <div className="clock"></div>
        <p style={{ marginTop: "7rem" }}>Loading...</p>
      </div>
    </Backdrop>
  );
}
